import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSelector from './LanguageSelector';
import './Header.css';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/engine', labelKey: 'nav.engine' },
    { path: '/applications', labelKey: 'nav.applications' },
    { path: '/licensing', labelKey: 'nav.licensing' },
    { path: '/providers', labelKey: 'nav.providers' },
    { path: '/about', labelKey: 'nav.about' },
  ];

  const isActive = (path: string) => location.pathname === path;

  useEffect(() => {
    if (!mobileMenuOpen) return;
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setMobileMenuOpen(false);
    };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [mobileMenuOpen]);

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="nav-brand">
          <img src="/assets/logo.png" alt="JuryView" className="logo" />
        </Link>

        <nav id="primary-navigation" className={`nav-menu ${mobileMenuOpen ? 'open' : ''}`}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`nav-link ${isActive(link.path) ? 'active' : ''}`}
              onClick={() => setMobileMenuOpen(false)}
            >
              {t(link.labelKey)}
            </Link>
          ))}
          <a
            href="https://app.juryview.com"
            className="nav-login"
            onClick={() => setMobileMenuOpen(false)}
          >
            {t('nav.login')}
          </a>
          <Link
            to="/contact"
            className="nav-cta"
            onClick={() => setMobileMenuOpen(false)}
          >
            {t('common.requestDocumentation')}
          </Link>
          <LanguageSelector />
        </nav>

        <button
          className="mobile-menu-toggle"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          aria-expanded={mobileMenuOpen}
          aria-controls="primary-navigation"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;
